// @styles
require('./aggregatorManageEntitiesView.scss');

// @vendors
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// @components
import { OKCover } from 'commonsComponents/OKCover';
import OKHeaderLanding from 'components/commons/OKHeaderLanding/OKHeaderLanding';
import { LoadingSection } from 'commonsComponents/loadingSection';
import TutorialLauncher from 'components/tutorial/tutorialLauncher';
import { CommercialAds } from 'components/commons/commercialAds/commercialAds';
import { ConfirmModal } from 'components/commons/confirmModal/confirmModal';
import AggregatorInfo from 'components/aggregator/aggregatorInfo/AggregatorInfo';
import { AggregatorManageEntities } from 'components/aggregator/aggregatorManageEntities/aggregatorManageEntities';

// @actions
import {
  removeEntity,
  toggleActive,
  getEntitiesData,
  getSecondFactorAuth,
} from 'actions/aggregator/aggregatorData';

// @utilities
import { getAggregatorDataAllProductsByBankCredential } from 'selectors/aggregator';
const { formatText } = require('core/i18n').i18n;

// @constants
const { GRAPHIC_TUTOR_TYPE_10 } = require('constants/index');
const TRANSLATION_KEY_PREFIX = 'aggregatorManageEntities';
const titleKey = TRANSLATION_KEY_PREFIX + '-headerTitle';

class AggregatorManageEntitiesViewClass extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      handleOnDirty: false,
      openModal: false,
      userBankId: null,
    };
  }

  componentWillUnmount() {
    const { dirty } = this.state;
    const { getEntitiesData } = this.props;
    if (!__CONTACT_CENTER__ && dirty) getEntitiesData();
  }

  handleOnDirty = () => {
    this.setState({ dirty: true });
  };

  showModal = userBankId => {
    this.setState({
      openModal: true,
      userBankId: userBankId,
    });
  };

  handleOnAcceptRemoveEntity = () => {
    const { userBankId } = this.state;
    const { removeEntity } = this.props;

    removeEntity(userBankId);
    this.setState({
      openModal: false,
      userBankId: null,
    });
  };

  handleOnCancelRemoveEntity = () => {
    this.setState({
      openModal: false,
      userBankId: null,
    });
  };

  renderSidebar = () => {
    return (
      <div className="aggregator-manage-entities__info grid-view--variable-cell-separation">
        <AggregatorInfo />
        <div className="aggregator-manage-entities__info__commercial">
          <CommercialAds path="global/entities/manage" type="banner-a" />
        </div>
      </div>
    );
  };

  renderContent = () => {
    const { productsByBank, toggleActive, isFetching, getSecondFactorAuth } = this.props;

    if (isFetching) return <LoadingSection />;

    return (
      <AggregatorManageEntities
        onHandleDirty={this.handleOnDirty}
        productsByBank={productsByBank}
        removeEntity={this.showModal}
        toggleActive={toggleActive}
        getSecondFactorAuth={getSecondFactorAuth}
      />
    );
  };

  render() {
    const tutorial = (
      <TutorialLauncher
        type={GRAPHIC_TUTOR_TYPE_10}
        title={formatText('tutorials-aggregatorManageEntitiesViewTitle')}
        subtitle={formatText('tutorials-aggregatorManageEntitiesViewSubtitle')}
        tooltip={formatText('tutorials-aggregatorManageEntitiesViewTooltip')}
      />
    );

    return (
      <div>
        <ConfirmModal
          open={this.state.openModal}
          title={formatText(`${TRANSLATION_KEY_PREFIX}-modalTitle`)}
          text={formatText(`${TRANSLATION_KEY_PREFIX}-modalText`)}
          onAccept={this.handleOnAcceptRemoveEntity}
          onCancel={this.handleOnCancelRemoveEntity}
        />
        <div className="container-fluid">
          <div className="row">
            <OKCover size="small" section="pg" customClass="col-xs-12">
              <OKHeaderLanding title={formatText(titleKey)} tutorial={tutorial}></OKHeaderLanding>
            </OKCover>
          </div>
        </div>
        <div className="grid-view__body">
          <div className="container-fluid">
            <div className="row aggregator-manage-entities">
              <div className="col-xs-12 col-md-8">{this.renderContent()}</div>
              <div className="col-xs-12 col-md-4">{this.renderSidebar()}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AggregatorManageEntitiesViewClass.propTypes = {
  productsByBank: PropTypes.object,
  removeEntity: PropTypes.func,
  toggleActive: PropTypes.func,
  getEntitiesData: PropTypes.func,
  isFetching: PropTypes.bool,
  getSecondFactorAuth: PropTypes.func,
};

const AggregatorManageEntitiesView = connect(
  state => {
    const productsByBank = getAggregatorDataAllProductsByBankCredential(state) || { size: 0 };
    return {
      productsByBank: productsByBank,
      isFetching: state.aggregatorData.get('isFetching') && !productsByBank.size,
    };
  },
  {
    removeEntity,
    toggleActive,
    getEntitiesData,
    getSecondFactorAuth,
  }
)(AggregatorManageEntitiesViewClass);

module.exports.constructor = AggregatorManageEntitiesView;
module.exports.AggregatorManageEntitiesView = AggregatorManageEntitiesView;
